<template>
  <b-row>
    <b-col v-if="!showInputs" class="text-right">
      <b-btn
        v-if="documentFilingDate"
        variant="outline-secondary"
        size="sm"
        @click="showInputs = true"
      >
        <i class="fa fa-calendar mr-2"></i>
        Change filing date
      </b-btn>

      <b-btn
        v-if="!documentFilingDate"
        variant="outline-primary"
        size="sm"
        @click="showInputs = true"
      >
        <i class="fa fa-check mr-2"></i>
        Mark as filed
      </b-btn>
    </b-col>

    <b-col cols="3" v-if="showInputs" class="text-right">
      <label class="form-control-label d-inline-block m-0" for="filing-date">Filed on</label>
    </b-col>
    <b-col cols="5" v-if="showInputs">
      <b-form-input id="filing-date" size="sm" type="date" v-model="newFilingDate"></b-form-input>
    </b-col>

    <b-col cols="4" v-if="showInputs" class="text-right">
      <b-btn
        size="sm"
        v-if="documentFilingDate"
        variant="warning"
        @click="unsetFilingDate"
        v-b-tooltip.hover
        title="Set as not filed"
      >
        <i class="fa fa-ban"></i>
      </b-btn>

      <b-btn
        size="sm"
        variant="default"
        @click="showInputs = false"
        v-b-tooltip.hover
        title="Cancel"
      >
        <i class="fa fa-times"></i>
      </b-btn>

      <b-btn
        size="sm"
        variant="success"
        @click="updateFilingDate"
        :disabled="saving"
        v-b-tooltip.hover
        title="Save"
      >
        <i class="fa fa-spin fa-spinner" v-if="saving"></i>
        <i class="fa fa-check" v-if="!saving"></i>
      </b-btn>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import { get } from "dot-prop";

export default {
  name: "document-filing-date-widget",
  props: {
    documentFilingDate: {
      type: String,
      description: "Filing date",
      required: false,
    },
    documentId: {
      type: String,
      description: "Document ID",
      required: true,
    },
    accountId: {
      type: String,
      description: "Account ID",
      required: true,
    },
    companyId: {
      type: String,
      description: "Company ID",
      required: true,
    },
  },
  data() {
    return {
      showInputs: false,
      newFilingDate: null,
      saving: false,
      errorMessage: null,
    };
  },
  created() {
    if (this.documentFilingDate) {
      this.newFilingDate = this.documentFilingDate;
    } else {
      this.newFilingDate = moment().format("YYYY-MM-DD");
    }
  },
  methods: {
    updateFilingDate: function () {
      this.saving = true;

      const requestBody = {
        filingDate: this.newFilingDate,
      };

      this.axios
        .patch(
          `/v1/accounts/${this.accountId}/companies/${this.companyId}/documents/${this.documentId}`,
          requestBody
        )
        .then((response) => {
          this.saving = false;
          // notify
          this.$notify({
            message: "Document updated",
            timeout: 3000,
            icon: "fa fa-check",
            type: "success",
          });

          // hide inputs
          this.showInputs = false;

          this.$emit("update-filing-date", response.data);
        })
        .catch((error) => {
          this.saving = false;
          this.errorMessage = "Failed to update document";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }

          this.$notify({
            message: `Error: ${this.errorMessage}`,
            timeout: 5000,
            icon: "fa fa-exclamation-triangle",
            type: "danger",
          });
        });
    },
    unsetFilingDate: function () {
      this.newFilingDate = null;
      this.updateFilingDate();
    },
  },
};
</script>